import { createI18n } from 'vue-i18n'
import de from './de.json'
import en from './en.json'

const messages = { de, en }

export type LocaleMessages = typeof de

/* Die gespeicherte Wahl gilt schon beim ersten Bild — sonst blitzt Deutsch auf
   und wird eine Zehntelsekunde später ersetzt. Ohne Vue gelesen, weil dieses
   Modul vor jedem Bauteil laeuft. Der Standard bleibt Deutsch, siehe
   `composables/useSprache.ts`. */
function startsprache(): 'de' | 'en' {
  try {
    const roh = localStorage.getItem('miracms.sprache')
    return roh === 'en' || roh === '"en"' ? 'en' : 'de'
  } catch {
    return 'de'
  }
}

const i18n = createI18n<[LocaleMessages], 'de' | 'en'>({
  legacy: false,
  globalInjection: true,
  locale: startsprache(),
  fallbackLocale: 'de',
  messages,
})

export default i18n
